module.exports = __webpack_public_path__ + "static/media/Standaardbijlage Marcom A 2018-2019.3faf3537.pdf";